import type ReactGridLayout from 'react-grid-layout';
import type { IconDefinition } from '@seeqdev/icons';

export enum ContentTypes {
  Visual,
  Text,
  Markdown,
}

export const DASHBOARD_BACKGROUND_MODES = {
  NONE: 'none',
  SOLID: 'solid',
  GRADIENT: 'gradient',
} as const;

export const DEFAULT_DASHBOARD_BORDER_WIDTH = 1;
export type DashboardBackgroundMode = (typeof DASHBOARD_BACKGROUND_MODES)[keyof typeof DASHBOARD_BACKGROUND_MODES];

export interface DashboardGradientBackground {
  from: string;
  to: string;
  angle: number;
}

export interface DashboardBackgroundStyle {
  mode: DashboardBackgroundMode;
  solidColor?: string;
  gradient?: DashboardGradientBackground;
}

export const HEADER_HEIGHT = 6;

export interface DashboardContent {
  type: ContentTypes;
  /** user given name; prefilled on content insertion */
  title: string;
  /**  indicates if title should be displayed or not */
  showTitle: boolean;
  /**  indicates if a border should be displayed or not */
  showBorder?: boolean;
  /** indicates the border width in pixels to render when borders are enabled */
  borderWidth?: number;
  /** indicates the border color to render when borders are enabled */
  borderColor?: string;
  /**  id of the content for the given tile */
  id: string;
  heading?: boolean;
  backgroundStyle?: DashboardBackgroundStyle | null;
}

export type DashboardTile = DashboardContent & ReactGridLayout.Layout;

export interface DashboardMenuAction {
  translationKey: string;
  action?: () => Promise<void> | void;
  menuActionName?: string;
  icon: IconDefinition;
  isActive?: boolean;
}

/**
 * Defines the allowed behaviors when adding new tiles to the dashboard in a position that is already occupied by an existing tile.
 * In 'auto-push' mode, the existing tile will automatically be pushed down to make room for the new tile.
 * In 'overlap' mode, the new tile will be added on top of the existing tile, allowing them to overlap.
 */
export type TileOverlapStatus = 'auto-push' | 'overlap';
